module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', {
    staticStyle: {
      "margin-bottom": "200px"
    },
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('h2', [_vm._v("拼团信息")]), _vm._v(" "), _c('content-block', {
    attrs: {
      "title": "关联产品id",
      "isRequired": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.relationMtDealId))]), _vm._v(" "), (this.mode === 'new') ? _c('Button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.pulling,
      "loading": _vm.pulling
    },
    on: {
      "click": _vm.pull
    }
  }, [(!_vm.pulling) ? _c('span', [_vm._v("拉取产品信息")]) : _c('span', [_vm._v("拉取中...")])]) : _vm._e()], 1), _vm._v(" "), _c('content-block', {
    attrs: {
      "title": "成团人数",
      "isRequired": ""
    }
  }, [_c('InputNumber', {
    attrs: {
      "disabled": this.mode !== 'new',
      "max": 1000,
      "min": 2
    },
    model: {
      value: (_vm.model.groupRule.groupNum),
      callback: function($$v) {
        _vm.model.groupRule.groupNum = $$v
      },
      expression: "model.groupRule.groupNum"
    }
  }), _vm._v("\n            "), _c('span', {
    staticClass: "icon-error help-icon"
  }), _vm._v(" 在\"团有效时间\"内满足\"成团人数\"才能拼团成功，取值范围[2, 1000]正整数\n    ")], 1), _vm._v(" "), _c('content-block', {
    attrs: {
      "title": "团有效时间",
      "isRequired": ""
    }
  }, [_c('Select', {
    staticClass: "inline-input nano-select",
    attrs: {
      "disabled": this.mode !== 'new'
    },
    model: {
      value: (_vm.model.groupRule.availableDays),
      callback: function($$v) {
        _vm.model.groupRule.availableDays = $$v
      },
      expression: "model.groupRule.availableDays"
    }
  }, _vm._l((16), function(n) {
    return _c('Option', {
      key: n - 1,
      attrs: {
        "value": n - 1
      }
    }, [_vm._v(_vm._s(n - 1))])
  })), _vm._v("\n        天\n        "), _c('Select', {
    staticClass: "inline-input nano-select",
    attrs: {
      "disabled": this.mode !== 'new'
    },
    model: {
      value: (_vm.model.groupRule.availableHours),
      callback: function($$v) {
        _vm.model.groupRule.availableHours = $$v
      },
      expression: "model.groupRule.availableHours"
    }
  }, _vm._l((23), function(n) {
    return _c('Option', {
      key: n,
      attrs: {
        "value": n
      }
    }, [_vm._v(_vm._s(n))])
  })), _vm._v("\n        小时\n            "), _c('span', {
    staticClass: "icon-error help-icon"
  }), _vm._v(" 1个拼团从发起开始进行倒计时\n    ")], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48f42a5e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/product/tuan/Rule.vue
// module id = 590
// module chunks = 0